import script from "./yc-popover-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./yc-popover-list.vue?vue&type=script&lang=ts&setup=true"

import "./yc-popover-list.vue?vue&type=style&index=0&id=dddfe7f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dddfe7f4"]])

export default __exports__